import React from 'react';
import { Drawer } from '../../components';
import { useStyles } from '../../services/material-ui';

import FormReasonRefusal from '../../components/FormReasonRefusal';

const CreateReasonRefusal: React.FC = () => {
  const classes = useStyles();
  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <FormReasonRefusal />
      </main>
    </div>
  );
};

export default CreateReasonRefusal;
